import { MutationTree } from 'vuex';
import { AuthState } from './types';

import { CognitoUser } from 'amazon-cognito-identity-js';

export const mutations: MutationTree<AuthState> = {
    setRestored: (state, user) => {
        state.user = user as CognitoUser;
        state.session = user.signInUserSession;

        //console.log('set restored', JSON.stringify(user));
        console.log('set restored', user.username);
    },

    setAuthenticated: (state, user) => {
        state.user = user as CognitoUser;
        state.session = user.signInUserSession;

        //console.log('set authenticated', JSON.stringify(user));
        console.log('set authenticated', user.username);
    },

    setNeedsPassword: (state, user) => {
        state.user = user as CognitoUser;
        console.log('set needs password', JSON.stringify(user));
    },

    setSignedOut: (state) => {
        state.user = null;
        state.session = null;
        console.log('set signed out', state);
    },

    setVerification: (state, payload) => {
        console.log('set verification', payload);
    },

    passwordReset: (state, payload) => {
        console.log('password reset', payload);
    },

    resetRequested: (state, payload) => {
        state.lastForgot = payload.email;
        console.log('reset requested', payload);
    },
};
